import script from "./MiddleContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./MiddleContainer.vue?vue&type=script&setup=true&lang=js"

import "./MiddleContainer.vue?vue&type=style&index=0&id=66915f1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66915f1a"]])

export default __exports__